<template>
<div
    v-if="choices != null"
>
    <v-select
        :label="label"
        :items="choices"
        :value="value"
        v-on:input="$emit('input', $event)"
    >
        <span
           slot="append-outer"
        >
            <v-icon
                color="primary"
                v-on:click="onClickAdd"
            >
                mdi-plus-circle-outline
            </v-icon>
        </span>
    </v-select>

    <m-edit-blobs-dialog
        ref="edit-blobs-dialog"
        v-on:ok="afterEditBlobsDialog($event)"
        :externally_visible="true"
        :allow_multiple="false"
        purpose="organization-logo"
        title="Add Organization Logo"
        :allow_media_assets="false"
        :organization_id="organization_id ?? $route.params.organization_id"
    />

</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        value: {
            type: String,
            default: function() { return null; }
        },

        organization_id: {
            type: String,
            default: function() { return null; }
        },

        label: {
            type: String,
            default: function() { return 'Logo Image'; }
        },
    },

    data() {
        return {
            choices: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/lightbox/organization-logos/:organization_id',
            
                'params' : {
                        'organization_id': this.organization_id ?? this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.choices = data.results;


                    },
            
                'on_error': 'Unable to get organization logos',
            });
        },

        onClickAdd()
        {
            this.$refs['edit-blobs-dialog'].showDialog();
        },

        afterEditBlobsDialog(results)
        {
            let orig = _.cloneDeep(this.choices).map(item => item.value);
        
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/lightbox/organization-logos/:organization_id',
            
                'params' : {
                        'organization_id': this.organization_id ?? this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.choices = data.results;

                        let difference = data.results.map(item => item.value)
                            .filter(item => !orig.includes(item));


                        if ( difference.length > 0 )
                        {
                            this.$emit('input', difference[0]);
                        }
                    },
            
                'on_error': 'Unable to get organization logos',
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>